export const expanderStyles = {
  backgroundColor: "#ffa11d",
  color: "white",
  padding: "0.5rem",
  borderRadius: "10px" /* Bo góc */,
  border: "1px solid #e0e0e0" /* Viền nhẹ */,
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)" /* Đổ bóng nhẹ */,
  transition: "all 0.3s ease",
};
export const captionSubject = {
  color: "white !important",
  fontSize: "14px",
  display: "inline-block",
  fontWeight: "bold",
};

export const txtBreakLine = {
  wordBreak: "break-word",
  whiteSpace: "normal",
  overflowWrap: "break-word",
};
